// Central place for the brand's social media URLs.
// Replace these with the real brand profiles when available.
export const SOCIAL_LINKS = {
  facebook: "https://www.facebook.com/",
  twitter: "https://twitter.com/",
  linkedin: "https://www.linkedin.com/",
  github: "https://github.com/",
};
